import AuthAPI from "./auth.js";
const Auth = new AuthAPI();

// Public
export function check(notarizationId) {
	return Auth.GET(`/Authorization/${notarizationId}/Check`);
}
